// eslint-disable

import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';

const routes = [
  ...ShopLoginPlugin.routes,
  ...AdminLoginPlugin.routes,
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage'),
    children: [
      {
        path: '/choix-utilisateur',
        name: 'Login',
        component: () => import('@/views/pages/UserLoginPage/Index.vue'),
        props: true,
        meta: {
          shopAuth: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout'),
    redirect: { name: 'Profile' },
    children: [
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        meta: { auth: true },
        props: {
          pageTitle: 'Mon profil',
        },
      },
      {
        path: '/profil-utilisateur',
        name: 'UserProfile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        props: (route) => ({
          userId: route.query.id,
          pageTitle: 'Profil utilisateur',
        }),
        meta: { auth: true },
      },
      {
        path: '/gestion-personnel',
        name: 'ManageUsers',
        component: () => import('@/views/pages/ManageUsersPage/Index.vue'),
        props: true,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    name: 'Home',
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
